import { EmailSchema, PhoneSchema } from "@/utils/commonSchema";
import { string, objectAsync, optionalAsync, pipe, trim, nonEmpty, type InferOutput, type InferInput } from "valibot";

export const SendQuestionSchema = objectAsync({
  email: EmailSchema,
  firstname: pipe(string("Prénom requis"), trim(), nonEmpty("Prénom requis")),
  lastname: pipe(string("Nom requis"), trim(), nonEmpty("Nom requis")),
  phone: optionalAsync(PhoneSchema),
  subject: pipe(string("Sujet requis"), trim(), nonEmpty("Sujet requis")),
  message: pipe(string("Message requis"), trim(), nonEmpty("Message requis")),
});

export type SendQuestionInput = InferInput<typeof SendQuestionSchema>;
export type SendQuestionOutput = InferOutput<typeof SendQuestionSchema>;
